import { render, staticRenderFns } from "./SurveyReview.vue?vue&type=template&id=6a983464&"
import script from "./SurveyReview.vue?vue&type=script&lang=js&"
export * from "./SurveyReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports